import allData from './allData'
import id from './id'
import pluck from './pluck'
import value from './value'

export default {
  allData,
  id,
  pluck,
  '() (value)': value
}



// WEBPACK FOOTER //
// ./src/data/api/object_manipulation/index.js